/**
 * watchdog自定义监控
 */
import watchdog from '@hll/watch-dog-jsutil';

// open in any env.
watchdog.setConfig({ silence: false });

export const sendEvent = (eventName, arg1, arg2) => {
  console.log('monitor_track:', eventName, arg1, arg2);
  try {
    arg1 = typeof arg1 !== 'string' ? JSON.stringify(arg1) : arg1;
    arg2 = typeof arg2 !== 'string' ? JSON.stringify(arg2) : arg2;

    watchdog.sendEvent(
      eventName,
      arg1,
      arg2,
    );
  } catch (e) {
    console.log(e);
  }
};
